import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Lock } from "lucide-react";
import { adminApi, errorText } from "./api";

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await adminApi.post("/login", { password }); onSuccess(); }
    catch (err) { setError(errorText(err, "Connexion impossible")); }
    finally { setBusy(false); }
  };

  return (
    <div className="vf-admin-login" data-testid="admin-login-page">
      <motion.form onSubmit={submit} initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }} data-testid="admin-login-form">
        <a className="vf-admin-logo" href="/" data-testid="admin-login-logo">Vibe<em>Fit</em></a>
        <p className="vf-kicker">Espace privé</p>
        <h1>L'atelier<br /><em>des commandes.</em></h1>
        <label className="vf-admin-field">
          <Lock size={15} />
          <input type="password" placeholder="Mot de passe administrateur" value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus data-testid="admin-password-input" />
        </label>
        {error && <p className="vf-admin-error" role="alert" data-testid="admin-login-error">{error}</p>}
        <button className="vf-btn-primary" type="submit" disabled={busy} data-testid="admin-login-submit">{busy ? "Vérification…" : "Entrer"} <ArrowRight size={15} /></button>
      </motion.form>
    </div>
  );
}
